import { render, staticRenderFns } from "./Accident.vue?vue&type=template&id=b251f598&scoped=true"
import script from "./Accident.vue?vue&type=script&lang=js"
export * from "./Accident.vue?vue&type=script&lang=js"
import style0 from "./Accident.vue?vue&type=style&index=0&id=b251f598&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b251f598",
  null
  
)

export default component.exports